import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-tutors-dialog',
  templateUrl: './tutors-dialog.component.html',
  styleUrls: ['./tutors-dialog.component.scss'],
})
export class TutorsDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TutorsDialogComponent>
  ) {}

  ngOnInit() {}

  onSubmit(tutors: any) {
    this.dialogRef.close(tutors);
  }

  onDismiss(dismiss: boolean) {
    sessionStorage.setItem('tutorsDismiss', JSON.stringify(dismiss));
    this.dialogRef.close();
  }
}
